import { styled } from 'styled-components';

import { EServiceLogoProps, LogoWithEServiceText } from './common/LogoWithEServiceText';
import { Flex } from '../Layout';
import { ForaLogo } from '../../assets/icons';
import { topBarStyle } from './common/commonStyles';

// This top bar is semantically a header since it does not contain any navigation elements.
const TopBar = styled.header`
  ${topBarStyle}
`;

type EServiceTopBarProps = Partial<EServiceLogoProps>;

export const EServiceTopBar = ({ eServiceText }: EServiceTopBarProps) => {
  return (
    <TopBar>
      <Flex alignItems="center" height="100%">
        {eServiceText ? <LogoWithEServiceText eServiceText={eServiceText} /> : <ForaLogo width={100} />}
      </Flex>
    </TopBar>
  );
};
